@if(authService.authenticated()) {
<app-header (toggleSidenav)="opened = !opened"></app-header>
<mat-sidenav-container autosize [class.is-fullscreen]="isFullScreen()" [class.is-footer]="isFooterVisible()">
    <mat-sidenav mode="side" [opened]="opened">
        <app-sidenav (navigate)="opened = false"></app-sidenav>
    </mat-sidenav>
    <div class="app-inner-content">
        @if(authService.authorizationDone()) {
        <ng-container *ngTemplateOutlet="contentEl"></ng-container>
        } @else {
        <div class="flex justify-center items-center gap-6 py-6 px-2">
            <mat-spinner [diameter]="32"></mat-spinner>
            <div>{{ 'PTC.CHECKING_PERMISSIONS' | translate }}</div>
        </div>
        }
    </div>
</mat-sidenav-container>
} @else {
<div class="app-home-content">
    <ng-container *ngTemplateOutlet="contentEl"></ng-container>
</div>
}

<ng-template #contentEl>
    <ng-content></ng-content>
</ng-template>
